import './Button.css';
const Button = (props) => {
  // console.log("getting data for Button ", props);
  let { type, label, onClick, disabled, buttonType } = props;

  
  return (
    <button
      type={buttonType}
      className={type}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  )
};

export default Button